import React from 'react';
import { NavLink } from 'react-router-dom';

const SB_WIDTH = 220;

const links = [
  { name: 'Meu painel', href: '/participante' },
  { name: 'Minhas avaliações', href: '/participante/avaliacoes' },
];

export default function ParticipanteSidebar() {
  return (
    <>
      <style>{`
#participante-sidebar-root{
  position:fixed;
  left:0;
  top:0;
  width:${SB_WIDTH}px;
  height:100dvh;
  background:#242F3C;
  color:#fff;
  z-index:1000;
  display:flex;
  flex-direction:column;
  padding-top:32px;
  overflow-y:auto;
}

@supports not (height: 100dvh){
  #participante-sidebar-root{ height:100vh; }
}

.participante-sidebar-title{
  font-weight:700;
  font-size:1.1rem;
  margin:0 0 16px 24px;
  letter-spacing:.5px;
}

.participante-sidebar-link{
  color:#fff;
  text-decoration:none;
  display:block;
  padding:14px 24px;
  font-weight:500;
  font-size:1rem;
  border-left:4px solid transparent;
  transition:background .16s, border-color .16s;
}

.participante-sidebar-link:hover{
  background:#2A3442;
}

.participante-sidebar-link.active{
  background:#232A34;
  border-left-color:#F36611;
}

@media (max-width:992px){
  #participante-sidebar-root{
    display:none !important;
  }
}

@media print{
  #participante-sidebar-root{
    display:none !important;
  }
}
      `}</style>

      <aside
        id="participante-sidebar-root"
        role="navigation"
        aria-label="Navegação do Participante"
      >
        <div className="participante-sidebar-title">
          Área do Participante
        </div>

        {links.map(link => (
          <NavLink
            key={link.href}
            to={link.href}
            end={link.href === '/participante'}
            className={({ isActive }) =>
              'participante-sidebar-link' + (isActive ? ' active' : '')
            }
          >
            {link.name}
          </NavLink>
        ))}
      </aside>
    </>
  );
}
